import {useMemo} from 'react';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import {useUpdateAuth} from "@/contexts/AuthProvider";
import {COOKIE_TOKEN_NAME} from "@/utils/const/cookie";

const useAxiosClient = () => {
    const [cookies] = useCookies([COOKIE_TOKEN_NAME]);  // Read 'token' cookie
    const { token } = cookies;
    const { logout } = useUpdateAuth();

    return useMemo(() => {
        const instance = axios.create({
            baseURL: process.env.NEXT_PUBLIC_ANALYTICS_ID,
        });

        if (token) {
            instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        }

        instance.interceptors.response.use(
            (response) => {
                // If the response is okay, return it
                return response;
            },
            (error) => {
                if (error.response && error.response.status === 401) {
                    //logout();
                }

                // Otherwise, the error should be handled in the catch block of the request
                return Promise.reject(error);
            }
        );

        return instance;
    }, [token]);
};

export default useAxiosClient;
